import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivitySummarize as ActivitySummarizeMutation,
    ActivitySummarizeVariables,
    ActivitySummarizeInput,
} from 'nutshell-graphql-types';

import ACTIVITY_SUMMARIZE from '../mutations/activity-summarize.graphql';

export const useActivitySummarize = (): {
    activitySummarize: (arg1: ActivitySummarizeInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [activitySummarize, {loading, error}] = useMutation<
        ActivitySummarizeMutation,
        ActivitySummarizeVariables
    >(ACTIVITY_SUMMARIZE);

    return {
        activitySummarize: (input: ActivitySummarizeInput) =>
            activitySummarize({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
